import { useEffect as w, useMemo as u, useState as t, useCallback as h } from "react";
const a = (e) => {
  w(() => (window.removeEventListener("resize", e), window.addEventListener("resize", e), () => {
    window.removeEventListener("resize", e);
  }), [e]);
}, z = () => {
  const { innerWidth: e, innerHeight: n } = u(() => typeof window < "u" ? window : { innerHeight: 0, innerWidth: 0 }, []), [i, s] = t(e), [r, o] = t(n), d = h(() => {
    s(e), o(n);
  }, [n, e]);
  return a(d), [i, r];
};
export {
  z as a,
  a as u
};
//# sourceMappingURL=use-window-size-CTHYqDff.js.map
